import {
  STORE_KEY_ACCOUNT,
  STORE_KEY_LOGIN_TYPE,
  evalCondition,
  notifyParent,
  storeGet,
} from 'mailup-react-helpers'

import { LOGIN_TYPE_ADMLIMITED } from 'Constants'

export const openRecipientNewTab = (idRecipient: number): void => {
  const { Domain } = storeGet(STORE_KEY_ACCOUNT)
  const pageId = 'RecipientsSummaryEmail'
  const r = `/recipients/list?rid=${idRecipient}`
  const route = `recipients_app_redirector.aspx?r=${encodeURIComponent(r)}`

  notifyParent('openNewTab', [
    `https://${
      Domain as string
    }/console/Main.aspx#/main?pageId=${pageId}&pageHref=${encodeURIComponent(
      route,
    )}`,
  ])
}

export const openRecipientsListInGroupNewTab = (
  idGroup: string | number,
): void => {
  const { Domain } = storeGet(STORE_KEY_ACCOUNT)
  const pageId = 'RecipientsSummaryEmail'
  const r = `/recipients/list?sig=${encodeURIComponent(idGroup)}`
  const route = `recipients_app_redirector.aspx?r=${encodeURIComponent(r)}`

  notifyParent('openNewTab', [
    `https://${
      Domain as string
    }/console/Main.aspx#/main?pageId=${pageId}&pageHref=${encodeURIComponent(
      route,
    )}`,
  ])
}

export const canViewExportStatus = (): boolean => {
  const loginType: number = storeGet(STORE_KEY_LOGIN_TYPE)

  return (
    loginType !== LOGIN_TYPE_ADMLIMITED &&
    evalCondition('uo:USER AND NOT uo:NOEXPORT')
  )
}

export const openExportStatus = (): void => {
  notifyParent('redirectMainFrame', ['/console/exported.aspx'])
}
